import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [categoryDropdown, setCategoryDropdown] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    setCategoryDropdown(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header className="relative z-50">
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled || !isHome
            ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-2 shrink-0"
            >
              <span className="font-heading text-2xl text-primary-500 whitespace-nowrap">
                89890漫画网
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              <Link
                to="/"
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === '/'
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'
                }`}
              >
                首页
              </Link>

              <div
                className="relative"
                onMouseEnter={() => setCategoryDropdown(true)}
                onMouseLeave={() => setCategoryDropdown(false)}
              >
                <button
                  className={`flex items-center gap-1 px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                    location.pathname.startsWith('/category')
                      ? 'text-primary-500 bg-primary-50'
                      : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'
                  }`}
                >
                  分类
                  <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${categoryDropdown ? 'rotate-180' : ''}`}></i>
                </button>
                {categoryDropdown && (
                  <div className="absolute top-full left-0 mt-1 w-44 bg-background-50 rounded-xl border border-background-200/70 py-2 animate-[fadeIn_0.15s_ease-out]">
                    {categories.map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50 transition-colors whitespace-nowrap"
                      >
                        <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
                        {cat.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              <Link
                to="/category/lianai"
                className="px-4 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50 transition-colors whitespace-nowrap"
              >
                排行榜
              </Link>

              <Link
                to="/about"
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === '/about'
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50'
                }`}
              >
                关于我们
              </Link>
            </div>

            <div className="hidden md:flex items-center gap-3">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="w-48 pl-9 pr-4 py-2 text-sm rounded-full bg-background-100 border border-background-200/70 text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                />
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              </div>
            </div>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="菜单"
            >
              <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 animate-[fadeIn_0.2s_ease-out]">
            <div className="px-4 py-3 space-y-1">
              <Link
                to="/"
                className={`block px-4 py-3 rounded-lg text-sm font-medium ${
                  location.pathname === '/' ? 'text-primary-500 bg-primary-50' : 'text-foreground-700'
                }`}
              >
                首页
              </Link>
              <div className="px-4 py-3">
                <p className="text-xs text-foreground-400 mb-2 font-medium">漫画分类</p>
                <div className="grid grid-cols-2 gap-1">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50 transition-colors"
                    >
                      <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
              <Link
                to="/category/lianai"
                className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700"
              >
                排行榜
              </Link>
              <Link
                to="/about"
                className={`block px-4 py-3 rounded-lg text-sm font-medium ${
                  location.pathname === '/about' ? 'text-primary-500 bg-primary-50' : 'text-foreground-700'
                }`}
              >
                关于我们
              </Link>
              <div className="px-4 py-3">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="搜索漫画..."
                    className="w-full pl-10 pr-4 py-2.5 text-sm rounded-full bg-background-100 border border-background-200/70 text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 transition-all"
                  />
                  <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}